import { Space } from "antd";
// import SelectedQuestionItem from "./SelectedQuestionItem";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import PickQuestionsTable from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/components/PickQuestionsTable";
import { useState, useEffect } from "react";

const SelectedQuestionsPanel = ({ setNewSelectedQuestions }: any) => {
  const { questions: Questions } = useQuizContext();
  const [qIdKey, setQIdKey] = useState<any>([]);
  useEffect(() => {
    if (Questions.length) {
      // setNewSelectedQuestions(Questions);
    }
  }, [Questions]);
  const handleRowSelection = (selectedRow: any) => {
    setNewSelectedQuestions(selectedRow);
  };
  return (
    <Space direction="vertical" style={{ width: "100%" }} size={16}>
      <PickQuestionsTable
        data={Questions}
        pagination={false}
        onSelectChange={handleRowSelection}
        qIdKey={qIdKey}
        setQIdKey={setQIdKey}
      ></PickQuestionsTable>
    </Space>
  );
};

export default SelectedQuestionsPanel;
